<template>
  <div v-if="canShowContent">
    <RenderContent
      :api-key="builderApiKey"
      :content="content"
      :custom-components="REGISTERED_COMPONENTS"
      model="page"
    />
  </div>
</template>

<script>
import { RenderContent, getContent, isPreviewing } from '@builder.io/sdk-vue';
import { useFetch, ref, useRoute, computed } from '@nuxtjs/composition-api';
import REGISTERED_COMPONENTS from '@/init-builder.ts';
import Analytics from '@/services/Analytics';

export default {
  name: 'BuilderIo',
  components: {
    RenderContent,
  },
  setup() {
    const builderApiKey = process.env.BUILDERIO;
    const content = ref(true);
    const canShowContent = computed(() => content.value || isPreviewing());
    const route = useRoute();
    const metaData = computed(() => {
      const meta = {};
      if (content.value && content.value.data) {
        meta.title = content.value.name;
        meta.description = content.value.data.description;
        meta.image = content.value.data.image;
      }

      return meta;
    });

    useFetch(async () => {
      content.value = await getContent({
        model: 'page',
        apiKey: builderApiKey,
        userAttributes: {
          urlPath: route.value.path,
        },
      });

      function fallbackReroute() {
        window.location.href = '/';
      }

      if (!content.value && process.client) {
        Analytics.track(
          'fallback-page-entry',
          {
            path: route.value.path,
          },
          {},
          // for optimal speed of reroute in non-adblock scenario
          fallbackReroute
        );

        // fallback reroute guarantee for adblock scenario
        setTimeout(() => {
          if (route.value.path !== '/') {
            fallbackReroute();
          }
        }, 1500);
      }

      return content;
    });

    if (!canShowContent.value) {
      Analytics.track('no-builder-content-available', {
        path: route.value.path,
      });
    }

    return {
      builderApiKey,
      REGISTERED_COMPONENTS,
      canShowContent,
      content,
      metaData,
    };
  },
  head() {
    return {
      title: this.metaData.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaData.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.metaData.image,
        },
      ],
    };
  },
};
</script>
